import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root'
})
export class EncryptfileService {

  secretKey = "MAKV2SPBNI992126";
  constructor() { }

  encrypt(value : string) : string{
    return CryptoJS.AES.encrypt(value.trim() ,this.secretKey.trim()).toString();
  }
  encryptUsingAES256(value) {
    let _key = CryptoJS.enc.Utf8.parse(this.secretKey);
    let _iv = CryptoJS.enc.Utf8.parse(this.secretKey);
    let encrypted = CryptoJS.AES.encrypt(
      JSON.stringify(value), _key, {
        keySize: 16,
        iv: _iv,
        mode: CryptoJS.mode.ECB
        // padding: CryptoJS.pad.Pkcs7
      });
      return encrypted.toString();
  }

  decrypt(textToDecrypt : string){
    return CryptoJS.AES.decrypt(textToDecrypt, this.secretKey.trim()).toString(CryptoJS.enc.Utf8);
  }
}
